import { render } from "./minor-info-form.component.vue?vue&type=template&id=804cfd4c&scoped=true&ts=true"
import script from "./minor-info-form.component.vue?vue&type=script&lang=ts"
export * from "./minor-info-form.component.vue?vue&type=script&lang=ts"

import "./minor-info-form.component.vue?vue&type=style&index=0&id=804cfd4c&scoped=true&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-804cfd4c"]])

export default __exports__